









import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})

export default class GearF extends Vue {
  /* TODO: Move data to service */
  private data() {
    return {
      gearA: {
        url: require('../assets/home-mech/gear-G_98x98.png'),
        alt: 'Gear F',
        highlight: require('../assets/home-mech/gear-G-high_98x98.png'),
        highAlt: 'Gear F highlight',
      },
    };
  }
}
